export const generateSmartIdCode: string = `
  mutation generateSmartIdCode($countryCode: String!, $identityNumber: String!) {
    generateSmartIdCode(countryCode: $countryCode, identityNumber: $identityNumber){
      code
    }
  }
`;
